import type { MenuConfig } from '~typings/menu'

export const defineMenu = /* @__PURE__ */ <Menu extends MenuConfig>(menuList: Menu[]) => menuList
